module.exports = __webpack_public_path__ + "img/shop.ad944295.svg";